import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Alert from '../Alert';

const Notification = ({ item, loading, close, init }) => {
    useEffect(() => {
        init();
    }, [init]);

    return (
        <div className="notification">
            {item ? <Alert {...item} loading={loading} onCloseCallback={close} /> : null}
        </div>
    );
};

Notification.propTypes = {
    item: PropTypes.object,
    loading: PropTypes.bool,
    close: PropTypes.func,
    init: PropTypes.func.isRequired
};

Notification.defaultProps = {
    item: null,
    loading: false,
    close: () => {}
};

export default Notification;
